import Index from "./";

// keep copy of index page at design-systems path
export default Index;
